import { faArrowRightFromBracket, faBars } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useLocale, useSelector } from 'hooks';
import Cookie from 'js-cookie';
import { useI18n } from 'locales';
import { useCallback, useEffect, useState } from 'react';
import { shallowEqual } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
// import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
// import ImgLogoH from 'assets/logo-h.png';
import { LanguageSwitcher } from '@/components/language-switcher';
import { clearAuthLogin, readCurrent } from '@/redux/actions';
import { Divider, Drawer, Typography } from '@mui/material';
import ImgLogoWavenex from 'assets/logo-wavenex.svg';
import { Button } from 'components/button';
import { LogoutDialog } from 'components/dialog';
import { NavMenu } from 'components/menu';
import { Sticky, StickyContainer } from 'react-sticky';

const drawerWidth = '14em';

const selector = (state) => {
  let isUnauthorized = false;

  state.errorsInfo.forEach((action) => {
    if (action.error && action.error.statusCode === 401) {
      isUnauthorized = true;
    }
  });

  return {
    isUnauthorized,
  };
};


function SegmentsLayout() {
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const location = useLocation();
  const { isUnauthorized } = useSelector(selector, shallowEqual);
  const dispatch = useDispatch();
  const locale = useLocale();
  const t = useI18n();

  useEffect(() => {
    const authLoginInfo = Cookie.get('authLoginInfo') ? JSON.parse(Cookie.get('authLoginInfo')) : null;
    if (authLoginInfo && authLoginInfo.token) {
      dispatch(readCurrent());
    } else {
      dispatch(clearAuthLogin());
      Cookie.remove('authLoginInfo');
      location.href = `/giving/login?locale=${locale}`;
    }
  }, [dispatch, locale]);

  const onLogoutHandler = useCallback(() => {
    setShowLogoutDialog(true);
  }, []);
  const onCloseLogoutDialogHandler = useCallback(() => {
    setShowLogoutDialog(false);
  }, []);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <StickyContainer>
      <Stack direction='row' sx={{ minHeight: '100vh' }}>
        <Drawer
          variant={isMobile ? 'temporary' : 'permanent'}
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          sx={{
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              borderRadius: 0,
              border: 0,
              backgroundColor: 'background.default',
              overflowY: 'unset',
              position: 'absolute',
            },
          }}
          anchor='left'
        >
          <Sticky>
            {({ style }) => (
              <Stack
                elevation={3}
                sx={(theme) => ({
                  border: 0,
                  borderRadius: 0,
                  borderBottomRightRadius: theme.spacing(1),
                  height: '100%',
                  overflowY: 'auto',
                  p: 1,
                  flexShrink: 1,
                  ...style,
                })}>
                <Stack sx={{ height: '100%', overflowY: 'scroll' }} gap={2}>
                  <Stack>
                    <NavMenu pathname={location.pathname} isMobile={isMobile} />
                  </Stack>

                  <Divider />

                  <Button
                    label={t('Logout')}
                    leading={faArrowRightFromBracket}
                    variant='menu'
                    onClick={onLogoutHandler}
                  />

                  <Stack
                    alignItems='center'
                    sx={{
                      p: 1,
                      flexShrink: 0,
                    }}
                  >
                    <Typography variant='caption'>Powered by</Typography>
                    <a href='https://wavenex.com.hk' target='_blank' rel='noreferrer'>
                      <img
                        src={ImgLogoWavenex}
                        alt='Wavenex'
                        width={80}
                        height={15.5}
                      />
                    </a>
                  </Stack>
                </Stack>
              </Stack>
            )}
          </Sticky>
        </Drawer>

        <Stack
          component='main'
          direction='column'
          sx={{
            marginLeft: isMobile ? 0 : drawerWidth,
            flexGrow: 1,
            flexShrink: 1,
            overflow: 'auto',
          }}
        >
          {isMobile && (
            <Stack
              direction='row'
              alignItems='center'
              justifyContent='space-between'
              sx={{ py: 1, pr: 2, borderBottom: '1px solid rgba(0,0,0,0.06)' }}
            >
              <Button
                leading={faBars}
                sx={{ fontSize: '20px' }}
                onClick={() => setOpenDrawer(true)}
              />

              <LanguageSwitcher />
            </Stack>
          )}

          <Outlet />
        </Stack>

        <LogoutDialog
          isOpen={isUnauthorized || showLogoutDialog}
          force={isUnauthorized}
          onClose={onCloseLogoutDialogHandler}
        />
      </Stack>
    </StickyContainer>
  );
}

export default SegmentsLayout;
